import { Table } from "@/features/Table";
import {
  type A5DerivativeUnderlyings,
  derivative_underlyings_columns,
} from "./columns";
import {
  type FilterA5DerivativeUnderlyingsSchema,
  FilterA5DerivativeUnderlyings,
} from "./filter";
import { useTranslation } from "react-i18next";

const client = "a5";
const table_name = "a5_derivative_underlyings";

export const A5DerivativeUnderlyingsTable = () => {
  const { t } = useTranslation();

  return (
    <Table<A5DerivativeUnderlyings, FilterA5DerivativeUnderlyingsSchema>
      label={t(`${table_name}.title`, {
        ns: "tables",
        defaultValue: "Structured product basket underlyings",
      })}
      client={client}
      table_name={table_name}
      columns={derivative_underlyings_columns}
      filter={<FilterA5DerivativeUnderlyings />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
